module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/evBoGU/images/cover.jpg?1684979252386",
      "alt": "This image is the cover for the book Missional Economics, The Gospel and Our Culture Series (GOCS)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Missional Economics, The Gospel and Our Culture Series (GOCS)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("American Christians today, says Michael Barram, have a signifi­cant blind spot when it comes to economic matters in the Bible. In this book Barram reads biblical texts related to matters of money, wealth, and poverty through a missional lens, showing how they function to transform our economic reasoning.")]), _c('p', [_vm._v("Barram searches for insight into God’s purposes for economic justice by exploring what it might look like to think and act in life-giving ways in the face of contemporary economic orthodoxies. The Bible repeatedly tells us how to treat the poor and marginalized, Barram says, and faithful Christians cannot but reflect carefully and concretely on such concerns.")]), _c('p', [_vm._v("Written in an accessible style, this biblically rooted study reflects years of research and teaching on social and economic justice in the Bible and will prove useful for lay readers, preachers, teachers, students, and scholars. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Barram, Walter Brueggemann\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0